import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'

export type SkeletonSeriesTreeProps = {
    items?: number
    fill?: boolean | number | string
}

const fillHeight = (fill: boolean | number | string) => {
    if (fill === false) return 320
    if (fill === true) return 'calc(100vh - 260px)'
    return fill
}

export default function SkeletonSeriesTree(props: Readonly<SkeletonSeriesTreeProps>) {
    const { items = 9, fill = true } = props

    return (
        <Stack spacing={1.5} sx={{ width: '100%' }}>
            <Stack direction="row" spacing={1.5} sx={{ alignItems: 'center' }}>
                <Skeleton variant="rounded" height={52} sx={{ flexGrow: 1, minWidth: 180 }} />
                <Skeleton variant="rounded" width={100} height={52} />
                <Skeleton variant="rounded" width={112} height={52} />
                <Skeleton variant="rounded" width={112} height={52} />
            </Stack>

            <Box
                sx={{
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: 1,
                    minHeight: fillHeight(fill),
                    p: 2,
                }}
            >
                <Stack direction="row" spacing={1} sx={{ alignItems: 'center', mb: 1.5 }}>
                    <Skeleton variant="circular" width={18} height={18} />
                    <Skeleton variant="text" width={220} />
                </Stack>

                <Stack spacing={1.25} sx={{ pl: 4 }}>
                    {Array.from({ length: items }, (_, index) => (
                        <Stack
                            key={index}
                            direction="row"
                            spacing={1}
                            sx={{ alignItems: 'center' }}
                        >
                            <Skeleton variant="circular" width={16} height={16} />
                            <Skeleton variant="text" width={`${28 + ((index * 17) % 38)}%`} />
                        </Stack>
                    ))}
                </Stack>
            </Box>

            <Stack direction="row" spacing={1.5} sx={{ alignItems: 'center' }}>
                <Skeleton variant="rounded" height={52} sx={{ flexGrow: 1, minWidth: 180 }} />
                <Skeleton variant="rounded" width={180} height={52} />
            </Stack>
        </Stack>
    )
}
